export default ($) => {
  let pathways = $('._pathways');

  pathways.each((index, el) => {
    let _el = $(el);
    let triggers = _el.find('.js-pathwayTrigger');
    let targets  = _el.find('.js-pathwayTarget');

    triggers.on('click', function (e) {
      e.preventDefault();

      let _this = $(this);

      if (_this.hasClass('-active')) return;

      targets.hide();
      triggers.removeClass('-active').attr('aria-pressed', 'false');
      _this.addClass('-active').attr('aria-pressed', 'true');

      let dataTarget = _this.data('trigger');

      targets.filter(`[data-trigger="${dataTarget}"]`).show();
    });
  })
}